class ShopTheLook {
  constructor(container) {
    this.container = container;
    this.id = container.dataset.sectionId;

    this.video = container.querySelector("video");

    this.emblaNode = container.querySelector(".embla");
    this.viewportNode = this.emblaNode?.querySelector(".embla__viewport");

    this.prevBtn = container.querySelector('[data-id="carousel-prev"]');
    this.nextBtn = container.querySelector('[data-id="carousel-next"]');

    this.initCarousel();
    this.initVideoObserver();
  }

  initCarousel() {
    if (!this.viewportNode) return;
    
    const options = { loop: false, align: "start" };
    this.emblaApi = EmblaCarousel(this.viewportNode, options);

    this.bind(this.emblaApi)
    this.updateButtons(this.emblaApi);
  }

  bind(emblaApi) {
    if(!emblaApi) return;

    this.onPrev = () => emblaApi.scrollPrev();
    this.onNext = () => emblaApi.scrollNext();

    this.prevBtn?.addEventListener("click", this.onPrev);
    this.nextBtn?.addEventListener("click", this.onNext);

    this.emblaApi.on("select", () => this.updateButtons(this.emblaApi));
    this.emblaApi.on("reInit", () => this.updateButtons(this.emblaApi));
  }

  updateButtons(emblaApi){
    if(!this.prevBtn || !this.nextBtn) return;

    this.prevBtn.classList.toggle("is-disabled", !emblaApi.canScrollPrev());
    this.nextBtn.classList.toggle("is-disabled", !emblaApi.canScrollNext());
  }

  initVideoObserver() {
    if (!this.video) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });
    });

    this.observer.observe(this.video);
  }

  destroy() {
    this.observer?.disconnect();

    this.prevBtn?.removeEventListener("click", this.onPrev);
    this.nextBtn?.removeEventListener("click", this.onNext);

    this.emblaApi?.destroy();
  }
}

/* ================================
   Section initialization
================================ */

const shopTheLookSections = {};

function initShopTheLook(scope = document) {
  scope
    .querySelectorAll('[data-section-type="aoc-shop-the-look"]')
    .forEach((container) => {
      const id = container.dataset.sectionId;

      if (shopTheLookSections[id]) {
        shopTheLookSections[id].destroy();
        delete shopTheLookSections[id];
      }

      shopTheLookSections[id] = new ShopTheLook(container);
    });
}

/* Web page load */
document.addEventListener("DOMContentLoaded", () => initShopTheLook());

if (window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", (e) =>
    initShopTheLook(e.target)
  );
}

/* Section unload */
document.addEventListener("shopify:section:unload", (e) => {
  const id = e.detail.sectionId;

  if (shopTheLookSections[id]) {
    shopTheLookSections[id].destroy();
    delete shopTheLookSections[id];
  }
});